<a *ngIf="isVisible | async" class="d-flex flex-row"
   [routerLink]="[searchLink]"
   [queryParams]="changeQueryParams" queryParamsHandling="merge"
   role="button" tabindex="0">
  <span class="filter-value px-1">{{filterValue.label}}</span>
  <span class="float-right filter-value-count ml-auto">
    <span class="badge badge-secondary badge-pill">{{filterValue.count | dsShortNumber}}</span>
  </span>
</a>
